import React, { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { ChevronUp, ChevronDown } from "lucide-react";
import { KPI_DEFS, SECTION_LABELS } from "./GaSections";

const GRAINS = [["date", "Day"], ["isoYearIsoWeek", "Week"], ["yearMonth", "Month"]];

export function LayoutPanel({ open, onOpenChange, layout, onSave }) {
  const [l, setL] = useState(layout);
  const move = (i, d) => { const o = [...l.order]; [o[i], o[i + d]] = [o[i + d], o[i]]; setL({ ...l, order: o }); };
  const toggle = (key, list) => setL({ ...l, [list]: l[list].includes(key) ? l[list].filter((x) => x !== key) : [...l[list], key] });
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md overflow-y-auto" data-testid="ga-layout-panel">
        <SheetHeader><SheetTitle>Customise my dashboard</SheetTitle></SheetHeader>
        <p className="text-xs text-slate-500 mt-1">Saved for you only.</p>
        <h3 className="text-xs font-semibold uppercase text-slate-400 mt-5 mb-2">Sections (order and visibility)</h3>
        <ul className="space-y-1">
          {l.order.map((s, i) => (
            <li key={s} className="flex items-center gap-2 rounded-lg border border-slate-200 px-2 py-1.5" data-testid={`ga-layout-section-${s}`}>
              <Switch checked={!l.hidden.includes(s)} onCheckedChange={() => toggle(s, "hidden")} data-testid={`ga-layout-toggle-${s}`} />
              <span className="flex-1 text-sm">{SECTION_LABELS[s]}</span>
              <button disabled={i === 0} onClick={() => move(i, -1)} className="p-1 rounded hover:bg-slate-100 disabled:opacity-30" data-testid={`ga-layout-up-${s}`}><ChevronUp className="w-4 h-4" /></button>
              <button disabled={i === l.order.length - 1} onClick={() => move(i, 1)} className="p-1 rounded hover:bg-slate-100 disabled:opacity-30" data-testid={`ga-layout-down-${s}`}><ChevronDown className="w-4 h-4" /></button>
            </li>
          ))}
        </ul>
        <h3 className="text-xs font-semibold uppercase text-slate-400 mt-5 mb-2">KPI cards</h3>
        <div className="flex flex-wrap gap-2">
          {Object.entries(KPI_DEFS).map(([k, [label]]) => (
            <button key={k} onClick={() => toggle(k, "kpis")} data-testid={`ga-layout-kpi-${k}`}
              className={`px-3 py-1 rounded-full text-xs border transition-colors ${l.kpis.includes(k) ? "bg-indigo-600 text-white border-indigo-600" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{label}</button>
          ))}
        </div>
        <h3 className="text-xs font-semibold uppercase text-slate-400 mt-5 mb-2">Trend chart grouping</h3>
        <div className="flex gap-2">
          {GRAINS.map(([k, label]) => (
            <button key={k} onClick={() => setL({ ...l, grain: k })} data-testid={`ga-layout-grain-${k}`}
              className={`px-3 py-1 rounded-full text-xs border ${l.grain === k ? "bg-indigo-600 text-white border-indigo-600" : "border-slate-200 text-slate-600"}`}>{label}</button>
          ))}
        </div>
        <Button className="w-full mt-6" onClick={() => onSave(l)} data-testid="ga-layout-save-btn">Save layout</Button>
      </SheetContent>
    </Sheet>
  );
}
